import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-data-questions',
  	templateUrl: './toolcards-data-questions.component.html',
  	styleUrls: ['./toolcards-data-questions.component.scss']
})
export class ToolcardsDataQuestionsComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;  		  		
  	}

}
